module.exports = __webpack_public_path__ + "static/media/avatar_horse.50f9a620.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_horse.png
// module id = 385
// module chunks = 0